import React from 'react'

const EditStringSvg = () => {
    return (
        <div className="edit-wrapper__icon">
            <svg version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px" y="0px" viewBox="0 0 20 20" overflow="visible" xmlSpace="preserve">
                <g>
                  <rect id="Rectangle_2880_2_" x="4.1" y="4.6" fill="#FFFFFF" width="11.9" height="11"/>
                </g>
                <g id="Group_1733" transform="translate(-188 -188)">
                  <path id="Path_1546" fill-rule="evenodd" fill="#0000FF" d="M194.3,190.6h7.5c2,0,3.7,1.7,3.7,3.7v7.5c0,2-1.7,3.7-3.7,3.7h-7.5
                    c-2,0-3.7-1.7-3.7-3.7v-7.5C190.6,192.2,192.2,190.6,194.3,190.6z M194.4,202.9l-0.8,0.2l0,0c-0.1,0-0.2,0-0.3,0h0
                    c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3l0,0c0-0.1,0-0.3,0-0.5l0.2-0.7c0.3,0.2,0.6,0.4,0.8,0.6
                    C194.1,202.4,194.3,202.6,194.4,202.9z M196.7,202.1c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1l-1.2,0.3
                    c-0.2-0.4-0.4-0.7-0.7-1c-0.3-0.3-0.6-0.6-1-0.7l0.3-1.1c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.3l0,0v0l6.1-6.1
                    c0.2-0.2,0.5-0.3,0.8-0.3l0,0c0.3,0,0.5,0.1,0.7,0.3l1.3,1.3c0.2,0.2,0.3,0.5,0.3,0.8l0,0c0,0.3-0.1,0.5-0.3,0.7L196.7,202.1
                    L196.7,202.1L196.7,202.1z"/>
                </g>
            </svg>
        </div>
    )
}

export default EditStringSvg;